import React, { useState,useEffect} from 'react'

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Card';
import trendingdata from '../Datas/trendingdata'
import {CartState} from '../context/contextmen'
import '../cssfiles/cardsgroup.css'

function cardsgroup() {
 
    const [productss, setProducts] = useState([]) 
    useEffect(() => {
     
    setProducts(trendingdata.productItems)
      
    }, [])
    const { dispatch} = CartState();
  return (

    
   
 <div > <h1 className='heading'>TRENDING</h1>
       {productss.map((prod, index)=>{
        prod.quantity = 1
        
      return  (

 
       <div className='display'>
      <Card key={index} style={{ width: '18rem' }}  className="cards">
        <Card.Img variant="top" src={ prod.Image } alt="PRODUCT" className="imagees"/>
        <Card.Body>
          <Card.Title>{prod.name}</Card.Title>
          <Card.Text>
          ${prod.price}
          </Card.Text>
          <Card.Text>
          {prod.description}
          </Card.Text>
          <Button className='btn btn-primary active' onClick={()=> dispatch({type : 'ADD_TO_CART', payload: prod})}>Add to cart</Button>
        </Card.Body>
        </Card>
        
        </div> 
       
)
        
       })}
   
    
   
  </div> 
   )}
export default cardsgroup

